var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSendArrowDs = function SvgSendArrowDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44741 2.11458C3.79118 1.77055 3 2.24278 3 2.97791V6.96279V8.91645V9.42729C3 9.99437 3.42911 10.4713 3.99773 10.5363L12.114 11.4641C12.6477 11.5251 12.6477 12.2929 12.114 12.3539L3.99773 13.2817C3.42911 13.3467 3 13.8236 3 14.3907V16.8862V18.8399V21.0027C3 21.519 3.42188 21.8787 3.93974 21.8198C4.45877 21.7607 2.44557 22.7533 21.4761 12.7723C22.1745 12.4059 22.1748 11.4121 21.4761 11.0456L4.44741 2.11458Z",
    fill: "#9496A9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSendArrowDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Send-arrow-ds.51872e1fd5da3a9a7a98b5b9ae7489a5.svg";